<template>
  <svg id="koeling" viewBox="0 0 64 64">
    <path
      d="M31.8,15.5c-9,0-16.3,7.4-16.3,16.5c0,9.1,7.3,16.5,16.3,16.5S48.1,41.2,48.1,32
                C48.1,22.9,40.8,15.5,31.8,15.5 M31.8,50.5c-10,0-18.2-8.3-18.2-18.5c0-10.2,8.2-18.5,18.2-18.5S50,21.9,50,32
                C50,42.2,41.8,50.5,31.8,50.5"
    />
    <rect x="30.8" y="0.3" width="1.9" height="9.1" />
    <path
      d="M31.8,15.5c-4.4,0-8.4,1.7-11.5,4.8c-3.1,3.1-4.8,7.3-4.8,11.7c0,4.4,1.7,8.6,4.8,11.7
                c3.1,3.1,7.2,4.8,11.5,4.8c4.3,0,8.4-1.7,11.5-4.8c6.3-6.4,6.3-16.9,0-23.4C40.2,17.2,36.1,15.5,31.8,15.5 M31.8,50.5
                c-4.9,0-9.4-1.9-12.9-5.4c-3.4-3.5-5.3-8.1-5.3-13.1c0-4.9,1.9-9.6,5.3-13.1c3.4-3.5,8-5.4,12.9-5.4c4.9,0,9.4,1.9,12.9,5.4
                c7.1,7.2,7.1,18.9,0,26.1C41.2,48.6,36.6,50.5,31.8,50.5"
    />
    <polygon points="15.4,16.8 9,10.3 10.4,8.9 16.7,15.4" />
    <path
      d="M31.8,15.5c-9,0-16.3,7.4-16.3,16.5c0,4.4,1.7,8.6,4.8,11.7c3.1,3.1,7.2,4.8,11.5,4.8c9,0,16.3-7.4,16.3-16.5
                C48.1,22.9,40.8,15.5,31.8,15.5 M31.8,50.5L31.8,50.5c-4.9,0-9.4-1.9-12.9-5.4c-3.4-3.5-5.3-8.1-5.3-13.1
                c0-10.2,8.2-18.5,18.2-18.5c10,0,18.2,8.3,18.2,18.5C50,42.2,41.8,50.5,31.8,50.5"
    />
    <rect x="0.6" y="31.1" width="9" height="1.9" />
    <path
      d="M31.8,15.5c-4.3,0-8.4,1.7-11.5,4.8c-6.3,6.4-6.3,16.9,0,23.4c3.1,3.1,7.2,4.8,11.5,4.8s8.4-1.7,11.5-4.8
                c6.3-6.4,6.3-16.9,0-23.4C40.2,17.2,36.1,15.5,31.8,15.5 M31.8,50.5c-4.9,0-9.4-1.9-12.9-5.4c-7.1-7.2-7.1-18.9,0-26.1
                c3.4-3.5,8-5.4,12.9-5.4s9.4,1.9,12.9,5.4c7.1,7.2,7.1,18.9,0,26.1C41.2,48.6,36.6,50.5,31.8,50.5"
    />
    <polygon points="10.4,55.1 9.1,53.8 15.4,47.3 16.8,48.7 	" />
    <path
      d="M31.8,15.5c-9,0-16.3,7.4-16.3,16.5c0,9.1,7.3,16.5,16.3,16.5l0,1v-1c9,0,16.3-7.4,16.3-16.5
                C48.1,22.9,40.8,15.5,31.8,15.5 M31.8,50.5L31.8,50.5c-10,0-18.2-8.3-18.2-18.5c0-10.2,8.2-18.5,18.2-18.5c4.9,0,9.4,1.9,12.9,5.4
                C48.1,22.5,50,27.1,50,32C50,42.2,41.8,50.5,31.8,50.5"
    />
    <rect x="30.8" y="54.6" width="1.9" height="9.1" />
    <path
      d="M31.8,15.5c-4.3,0-8.4,1.7-11.5,4.8c-6.3,6.4-6.3,16.9,0,23.4c3.1,3.1,7.2,4.8,11.5,4.8
                c4.4,0,8.4-1.7,11.5-4.8c3.1-3.1,4.8-7.3,4.8-11.7c0-4.4-1.7-8.6-4.8-11.7S36.1,15.5,31.8,15.5 M31.8,50.5c-4.9,0-9.4-1.9-12.9-5.4
                c-7.1-7.2-7.1-18.9,0-26.1c3.4-3.5,8-5.4,12.9-5.4c4.9,0,9.4,1.9,12.9,5.4S50,27.1,50,32s-1.9,9.6-5.3,13.1
                C41.2,48.6,36.6,50.5,31.8,50.5"
    />
    <polygon points="53.2,55.1 46.8,48.7 48.2,47.3 54.5,53.8" />
    <path
      d="M31.8,15.5c-4.4,0-8.4,1.7-11.5,4.8c-3.1,3.1-4.8,7.3-4.8,11.7c0,9.1,7.3,16.5,16.3,16.5
                c4.4,0,8.4-1.7,11.5-4.8c3.1-3.1,4.8-7.3,4.8-11.7c0-4.4-1.7-8.6-4.8-11.7S36.1,15.5,31.8,15.5 M31.8,50.5L31.8,50.5
                c-10,0-18.2-8.3-18.2-18.5c0-4.9,1.9-9.6,5.3-13.1c3.4-3.5,8-5.4,12.9-5.4c4.9,0,9.4,1.9,12.9,5.4C48.1,22.5,50,27.1,50,32
                c0,4.9-1.9,9.6-5.3,13.1C41.2,48.6,36.7,50.5,31.8,50.5"
    />
    <rect x="54" y="31.1" width="9" height="1.9" />
    <polygon points="48.2,16.8 46.8,15.4 53.2,8.9 54.5,10.3" />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconKoeling extends Vue {}
</script>
